import { Injectable } from '@angular/core';
import { IAdapter } from 'src/app/models';
import { MouldDecisionTool } from 'src/app/models/domain';
import { IMouldDecisionToolResponse } from 'src/app/models/share-point';

@Injectable({
  providedIn: 'root',
})
export class MouldDecisionToolAdapter implements IAdapter<
  MouldDecisionTool,
  IMouldDecisionToolResponse
> {
  public adaptToDomain(mdtResponse: IMouldDecisionToolResponse): MouldDecisionTool {
    return new MouldDecisionTool(
      mdtResponse.webUrl,
      mdtResponse.fileName,
      mdtResponse.name,
      mdtResponse.id,
      mdtResponse.UGS_x0020_code,
      mdtResponse.Financial_x0020_Recommendation,
      mdtResponse.Selected_x0020_Proposal,
      mdtResponse.Comment,
      mdtResponse.Mould_x0020_Layout,
      mdtResponse.Mould_x0020_Type,
      mdtResponse.Elements,
      mdtResponse.Cycletime,
      mdtResponse.Mould_x0020_Price
    );
  }
}
